<mat-icon *im2mLet="stateData$ | async as stateData" [matTooltip]="stateData?.tooltip | transloco" [ngClass]="stateData?.style">insert_link</mat-icon>
